import { render, staticRenderFns } from "./goodsPropaganda.vue?vue&type=template&id=4442da56&scoped=true"
import script from "./goodsPropaganda.vue?vue&type=script&lang=js"
export * from "./goodsPropaganda.vue?vue&type=script&lang=js"
import style0 from "./goodsPropaganda.vue?vue&type=style&index=0&id=4442da56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4442da56",
  null
  
)

export default component.exports